var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ctrl-columns"},[_c('h1',[_vm._v(_vm._s(_vm.categoryData.name)+"の買取コラム一覧")]),_c('div',{staticClass:"wrap1100"},[_c('ColumnList',{attrs:{"categoryId":_vm.categoryId}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }